import React, { useEffect } from 'react'
import './NoEmailIntegration.scss'
import { Link } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useLazyGetMeQuery } from '../../store/user/user'
import { setCurrentUser } from '../../store/emailHub/emailUsers'
import { useMailCapability } from '../../store/onboarding/useMailCapability'
import { useUserHasScopedBlockAccess } from '../ScopedBlock/hooks'
import { OnboardingIntegrationStep } from '../../views/Growth/Onboarding/OnboardingIntegrationStep/OnboardingIntegrationStep'
import { Spinner } from '../Spinner/Spinner'

export const NoEmailIntegration: React.FC = () => {
  const dispatch = useAppDispatch()
  const accountId = useAppSelector(selectAccountId)
  const { allowedServiceIds, isFulfilled, isLoading } = useMailCapability()
  const [triggerGetMe] = useLazyGetMeQuery()
  const { userHasScopedBlockAccess } = useUserHasScopedBlockAccess()
  const [hasConnectAccess] = userHasScopedBlockAccess([], undefined, { scope: 'integration:connect', superScope: ['integration:admin'] })

  useEffect(() => {
    if (!isFulfilled) {
      return
    }
    const refreshCurrentUser = async () => {
      const { data: currentUser } = await triggerGetMe({ accountId }, true)
      if (currentUser) {
        dispatch(setCurrentUser(currentUser))
      }
    }
    refreshCurrentUser()
  }, [isFulfilled, accountId, triggerGetMe, dispatch])

  if (isLoading) {
    return (
      <div className='d-flex align-items-center justify-content-center w-100 p-4'>
        <Spinner />
      </div>
    )
  }

  return (
    <div className='d-flex align-items-center justify-content-center w-100 p-4'>
      <div className='rounded-4 p-4 no-email-container'>
        <OnboardingIntegrationStep
          icon={<i className='bi bi-envelope' />}
          headerTitle='Unlock your AI-powered inbox'
          headerSubtitle='Connect your email account to unlock smart categorization, contextual intelligence, and automated client updates. Turn email overwhelm into organized productivity.'
          serviceIds={allowedServiceIds}
          disabled={!hasConnectAccess}
          postConnectRedirectPath={window.location.pathname}
          secondaryAction={
            <Link className='zocks-text-primary button-link-medium' to='/account/profile-settings/integrations'>
              See all supported providers
            </Link>
          }
        />
      </div>
    </div>
  )
}
